module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_8023.bd527ec0.png";